export type ListType = {
    name: string;
    type: string;
};
